<router-outlet></router-outlet>
<div class="popup-backdrop fade show app-loader-backdrop" [ngClass]="helper.myLoading || routeBusy ? '' : 'd-none'">
  <div id="loading-bar-spinner" class="spinner">
    <div class="spinner-icon"></div>
  </div>
</div>
